"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import { SiteNavbar } from "@/shared/ui/site-navbar";
import { SiteFooter } from "@/shared/ui/site-footer";
import { ContactHero } from "@/features/contact/presentation/components/contact-hero";
import { ContactForm } from "@/features/contact/presentation/components/contact-form";
import { ContactInfo } from "@/features/contact/presentation/components/contact-info";
import { ContactNote } from "@/features/contact/presentation/components/contact-note";
import type { ContactPageContent } from "@/features/contact/types/contact-page-content";
interface ContactPageProps {
  content: ContactPageContent;
}
export function ContactPage(t0) {
  const $ = _c(33);
  const {
    content
  } = t0;
  const {
    footer,
    form,
    hero,
    infoItems,
    navigation,
    note
  } = content;
  let t1;
  if ($[0] !== navigation) {
    t1 = <SiteNavbar content={navigation} />;
    $[0] = navigation;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hero) {
    t2 = <ContactHero content={hero} />;
    $[2] = hero;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0,
      y: 24
    };
    t4 = {
      opacity: 1,
      y: 0
    };
    t5 = {
      once: true,
      margin: "-80px"
    };
    t6 = {
      duration: 0.65,
      ease: "easeOut"
    };
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="mb-8"><div className="mb-4 inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/5 px-4 py-1.5 shadow-sm"><span className="h-1.5 w-1.5 rounded-full bg-primary" /><span className="text-xs font-semibold tracking-wider text-primary uppercase">Send a message</span></div><h2 className="text-3xl leading-[1.15] font-semibold tracking-tight text-balance text-foreground sm:text-4xl">Tell us what's on your mind</h2><p className="mt-3 max-w-md leading-relaxed text-muted-foreground">Fill out the form and our team will get back to you within one business day.</p></div>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== form) {
    t8 = <motion.div initial={t3} whileInView={t4} viewport={t5} transition={t6}>{t7}<ContactForm content={form} /></motion.div>;
    $[9] = form;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t10;
  let t11;
  let t12;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      opacity: 0,
      y: 24
    };
    t10 = {
      opacity: 1,
      y: 0
    };
    t11 = {
      once: true,
      margin: "-80px"
    };
    t12 = {
      duration: 0.65,
      ease: "easeOut",
      delay: 0.1
    };
    $[11] = t10;
    $[12] = t11;
    $[13] = t12;
    $[14] = t9;
  } else {
    t10 = $[11];
    t11 = $[12];
    t12 = $[13];
    t9 = $[14];
  }
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="mb-6"><div className="mb-4 inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/5 px-4 py-1.5 shadow-sm"><span className="h-1.5 w-1.5 rounded-full bg-primary" /><span className="text-xs font-semibold tracking-wider text-primary uppercase">Contact info</span></div><h2 className="text-2xl font-semibold tracking-tight text-foreground">Other ways to reach us</h2></div>;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== infoItems) {
    t14 = <motion.div initial={t9} whileInView={t10} viewport={t11} transition={t12}>{t13}<ContactInfo items={infoItems} /></motion.div>;
    $[16] = infoItems;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== note) {
    t15 = <ContactNote content={note} />;
    $[18] = note;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t14 || $[21] !== t15) {
    t16 = <div className="flex flex-col gap-8">{t14}{t15}</div>;
    $[20] = t14;
    $[21] = t15;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== t16 || $[24] !== t8) {
    t17 = <section className="w-full py-20 sm:py-28"><div className="mx-auto max-w-7xl px-6 lg:px-8"><div className="grid grid-cols-1 gap-12 lg:grid-cols-[1fr_420px] lg:gap-16 xl:gap-20">{t8}{t16}</div></div></section>;
    $[23] = t16;
    $[24] = t8;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== footer) {
    t18 = <SiteFooter content={footer} />;
    $[26] = footer;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== t1 || $[29] !== t17 || $[30] !== t18 || $[31] !== t2) {
    t19 = <main className="relative flex flex-1 flex-col bg-background">{t1}{t2}{t17}{t18}</main>;
    $[28] = t1;
    $[29] = t17;
    $[30] = t18;
    $[31] = t2;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  return t19;
}